module.exports = __webpack_public_path__ + "images/978a8fca7fd5a1423f7473ccab91d9cd-illu_dir_recessed4.png";